module.exports = "/images/ugt_logo.png?6d33f67d0ad7bd9ef975e8e5995658c8";